<template>
  <main id="app">
    <PageHeader />
    <router-view
      @multiple-start="multipleExporting = true"
      @multiple-end="multipleExporting = false"
    />
    <PageFooter />
    <ipad-mouse
      v-if="showIpadMouse"
      :force-show-cursor="multipleExporting"
      rectSelector=".__cursor_rect"
      textSelector=".__cursor_text"
    />
  </main>
</template>

<script>
export default {
  data() {
    return {
      multipleExporting: false,
    };
  },
  components: {
    IpadMouse: () => import("@/components/IpadMouse"),
    PageHeader: () => import("./views/PageHeader"),
    PageFooter: () => import("./views/PageFooter"),
  },

  computed: {
    showIpadMouse() {
      return !/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(
        navigator.userAgent
      );
    },
  },
};
</script>

<style lang="scss">
body,
html {
  font-family: PingFang SC, Microsoft Yahei, Roboto, Arial, sans-serif;
  width: 100%;
  height: 100%;
  background-color: #eee;
  overflow: hidden;
}
span {
  font-family: PingFang SC, Microsoft Yahei, Roboto, Arial, sans-serif;
}

:root {
  --highlight-bg: #fff;
}

#app {
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

a {
  color: unset;
  &:visited {
    color: unset;
  }
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(to right, #0faeca, #d4f9ff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  padding-left: 10px;
}

.logo-link {
  width: 200px;
  height: 50px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  transition: all 0.15s ease;
  text-decoration: none;
  padding: 2px 6px;
}

@media (prefers-color-scheme: dark) {
  body,
  html {
    background-color: #333333;
  }
  :root {
    --highlight-bg: #494949;
  }
}

body.darkmode:not(.darkmode-off) {
  background-color: #333333;
  :root {
    --highlight-bg: #494949;
  }
}
</style>
